import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getClips(ctx) {
    try {
      const response = await api.getClips();
      ctx.commit("getClipsSuccess", {
        clips: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async createClip(ctx, params) {
    try {
      const response = await api.createClip(params);
      ctx.commit("createClipSuccess", {
        clip: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async deleteClip(ctx, params) {
    try {
      await api.deleteClip(params);
      ctx.commit("deleteClipSuccess", {
        clipId: params.clip_id
      });
    } catch (error) {
      throw error;
    }
  }
};

export default actions;
